
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.674 15c0 8.105-6.57 14.674-14.674 14.674S.326 23.104.326 15 6.896.326 15 .326c8.105 0 14.674 6.57 14.674 14.674","fill":"#E8E8E6"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.239 15c0 7.312-5.928 13.24-13.24 13.24-7.31 0-13.238-5.928-13.238-13.24C1.76 7.69 7.688 1.761 15 1.761c7.311 0 13.239 5.928 13.239 13.24","fill":"#E8E8E6"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.113 8.645a.304.304 0 00-.3.259.515.515 0 11-1.018-.149 1.335 1.335 0 011.318-1.146h7.542c.736 0 1.332.6 1.332 1.34v4.562l.973 1.694c.67 1.167-.168 2.625-1.509 2.625H20.85a.516.516 0 01-.515-.517c0-.286.231-.518.515-.518h1.602c.451 0 .763-.404.706-.812h-2.466a.516.516 0 01-.515-.518c0-.286.23-.517.515-.517h1.932l-.448-.78h-1.484a.516.516 0 01-.515-.518c0-.286.23-.518.515-.518h1.267V8.95a.304.304 0 00-.303-.304h-7.542zM8.72 11.507a.455.455 0 00-.454.457v5.052h9.844v-5.052a.455.455 0 00-.454-.457H8.719zm9.607 6.544H8.048l-.7 1.22h11.678l-.7-1.22zm1.206 2.255a.943.943 0 01-.934 1.05H7.776a.943.943 0 01-.934-1.05h12.69zM7.235 17.395v-5.431c0-.824.665-1.492 1.484-1.492h8.936c.819 0 1.483.668 1.483 1.492v5.43l1.165 2.03c.757 1.318-.19 2.967-1.705 2.967H7.776c-1.515 0-2.462-1.649-1.705-2.967l1.164-2.03z","fill":"#202D38"}})])
          )
        }
      }
    